import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { OrderHistoryItemLoadingDesktop } from './desktop';
import { OrderHistoryItemLoadingMobile } from './mobile';
import { OrderHistoryItemLoadingTablet } from './tablet';

export const OrderHistoryItemLoading: React.FC = () => {
  const responsiveTable = useBreakpointValue({
    base: <OrderHistoryItemLoadingMobile />,
    sm: <OrderHistoryItemLoadingTablet />,
    lg: <OrderHistoryItemLoadingDesktop />,
  });

  return responsiveTable;
};
